import Account from "@/helper/AccountHelper.js";

export default {
    data: function () {
        return {
            isAccountLoaded: false,
            isLogin: false,
            isLine: false,
            user: {},
            profile: {},
            profileExtendJson: {},
            point: 0,
            pointDate: 0,
            linePicture: '',
        };
    },
    created: function () {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.user = Account.getCacheUser();
            this.profile = Account.getCacheProfile();
            this.profileExtendJson = Account.getCacheProfileExtendJson();
            // this.point = Account.getCachePoint();
            this.point = this.profile && this.profile.updated_points ? this.profile.updated_points.points :  Account.getCachePoint();
            this.pointDate = Account.getCachePointUpdateDate();
        }).finally(() => {
            this.isAccountLoaded = true;
            this.getAccountInitiated();
            if (this.user) {
                this.updateTheme(this.user.userLevel);

                if (this.user.line) {
                    this.isLine = true;
                }
            }
        });
    },
    methods: {
        getAccountInitiated: function () {
            if (this.isAccountLoaded) {
                if (typeof this.accountInitiated == 'function') {
                    this.accountInitiated();
                }
            } else {
                setTimeout(() => {
                    this.getAccountInitiated();
                }, 250);
            }
        },
        getToken: function () {
            return Account.getToken();
        },
        getUserPoint: function () {
            this.point = Account.getCachePoint();
        },
        updateUserPoint: function (updatedPoint) {
            if (!updatedPoint) return;

            Account.updatePoint(updatedPoint);
            this.getUserPoint();
        },
        getPictureLine: function () {
            var userCache = Account.getCacheUser();
            if (userCache && userCache.line) {
                this.isLine = true;
                this.linePicture = userCache.line.pictureUrl;
            }
            return this.linePicture;
        },
        updateTheme: function (userlevel) {
            if (!userlevel) return;

            switch (userlevel) {
                case 1:
                    this.$store.commit('changeUserType', 'farmer');
                    break;
                case 2:
                    this.$store.commit('changeUserType', 'sale');
                    break;
                case 4:
                    this.$store.commit('changeUserType', 'subdist');
                    break;
                case 8:
                    this.$store.commit('changeUserType', 'dist');
                    break;
                default:
                    this.$store.commit('changeUserType', 'farmer');
                    break;
            }
        }
    }
}
